import actPageDictionary from '@pages/act/i18n/ru/act.dic.json';

export const actPage = {
  ACT_PAGE: actPageDictionary,
};

export const actPageNamespaces = Object.keys(actPage);
